import { useRef } from 'react';
import { useSize } from 'ahooks';
import { Image, ImageProps } from 'antd';
import clsx from 'clsx';

import { imgFallback, weave } from 'utils';

export const MilesImage = ({
  alt,
  src,
  isNew,
  width,
  height,
  preview,
  className,
  isFullHeight = true,
}: ImageProps & { isFullHeight?: boolean; isNew?: boolean; }) => {
  const ref = useRef<HTMLDivElement>(null);
  const divSize = useSize(ref.current);

  const wh = width || divSize?.width;
  const ht = height || divSize?.height;

  return (
    <div
      ref={ref}
      className={clsx(!width && 'w-full', (isFullHeight && !height) && 'h-full')}
    >
      {(!src && !isNew)
        ? (
          <Image
            alt={alt}
            src={`data:image/svg+xml;base64,${weave(wh, ht)}`}
            width={wh}
            height={ht}
            preview={false}
          />
        )
        : (
          <Image
            alt={alt}
            src={src}
            width={wh}
            height={height}
            preview={preview}
            className={clsx(className, 'object-contain')}
            fallback={imgFallback}
          />
        )}
    </div>
  );
};
